import { Button } from '@/components/ui/button'
import BarChart from './chart/bar-chart'
import LineChart from './chart/line-chart'
import StatsBarChart from './chart/stats-bar-chart'
import { Route as accountsOverviewRoute } from '@/routes/(app)/_layout/accounts/index'
import { convertToCurrencyRounded } from '@/utils/currency_converter'
import { useNavigate } from '@tanstack/react-router'
import dayjs from 'dayjs'
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import getPharmacyID from '@/utils/pharmacy_code'

const Component = () => {
    const { current_week_revenue, last_week_revenue, current_week_cog, last_week_cog, current_week_pl, last_week_pl } = accountsOverviewRoute.useLoaderData();
    const navigate = useNavigate();
    const mapped_cog = current_week_cog.map((item) => {
        return {
            day: dayjs(item.time_interval).format('ddd'),
            "COG": item.total_revenue
        }
    })
    const mapped_pl = current_week_pl.map((item) => {
        return {
            time_interval: dayjs(item.time_interval).format('ddd'),
            "Profit/Loss": item.total_revenue
        }
    })
    const this_week_cog_total = current_week_cog.reduce((acc, item) => acc + item.total_revenue, 0)
    const last_week_cog_total = last_week_cog.reduce((acc, item) => acc + item.total_revenue, 0)

    return (
        <>
            <div className="overflow-y-scroll h-screen pb-48">
                <div className="flex items-center justify-between">
                    <div>
                        <h2 className="text-2xl font-bold tracking-tight">Accounts Overview</h2>
                        <p className="text-muted-foreground">
                            Click on any of the cards to get more detailed view with more filters.
                        </p>
                    </div>
                    <Button
                        variant={"secondary"}
                    >
                        Customize
                    </Button>
                </div>
                <hr className="my-4" />
                <h2 className='text-3xl font-semibold mt-8 mb-4'>Revenue</h2>
                <div className='flex flex-col flex-1 gap-3'>
                    <StatsBarChart
                        title="Revenue (Weekly)"
                        value={convertToCurrencyRounded(current_week_revenue.reduce((acc, item) => acc + item.total_revenue, 0))}
                        trend={convertToCurrencyRounded(last_week_revenue.reduce((acc, item) => acc + item.total_revenue, 0)) + " vs Last Week"}
                        trendDirection={
                            last_week_revenue.reduce((acc, item) => acc + item.total_revenue, 0) > current_week_revenue.reduce((acc, item) => acc + item.total_revenue, 0) ? 'down' : 'up'
                        }
                        data={current_week_revenue}
                        xAxisKey="time_interval"
                        dataKey="total_revenue"
                        color="#71717A"
                        footer="Showing total revenue for the last 7 days"
                        onClick={() => {
                            navigate({
                                to: '/accounts/revenue',
                            })
                        }}
                        active={true}
                    />
                </div>

                <hr className="my-4" />

                <div className='grid grid-cols-3 gap-x-6'>
                    <BarChart
                        title="COGS"
                        value={convertToCurrencyRounded(this_week_cog_total)}
                        trend={`${convertToCurrencyRounded(Math.abs(this_week_cog_total - last_week_cog_total))} ${this_week_cog_total > last_week_cog_total ? 'more' : this_week_cog_total < last_week_cog_total ? 'less' : ''} vs Last Week`}
                        data={mapped_cog}
                        xAxisKey="day"
                        dataKey="COG"
                        color="#1458DD"
                        footer="Showing COG for the last 7 days"
                        active={true}
                        onClick={() => {
                            navigate({
                                to: '/accounts/cost-of-goods'
                            })
                        }}
                    />
                    <LineChart
                        title="Profit & Loss"
                        value={convertToCurrencyRounded(current_week_pl.reduce((acc, item) => acc + item.total_revenue, 0))}
                        trend={
                            (() => {
                                const thisWeek = current_week_pl.reduce((acc, item) => acc + item.total_revenue, 0);
                                const lastWeek = last_week_pl.reduce((acc, item) => acc + item.total_revenue, 0);
                                const diff = Math.abs(thisWeek - lastWeek);
                                let direction = '';
                                if (thisWeek > lastWeek) direction = 'more';
                                else if (thisWeek < lastWeek) direction = 'less';
                                return `${convertToCurrencyRounded(diff)} ${direction} vs Last Week`;
                            })()
                        }
                        data={mapped_pl}
                        xAxisKey="time_interval"
                        dataKey="Profit/Loss"
                        color="#1458DD"
                        active={true}
                        footer='Showing Profit & Loss for the last 7 days'
                        onClick={() => {
                            navigate({
                                to: '/accounts/profit-loss'
                            })
                        }}
                    />
                </div>
            </div>
        </>
    )
}

export default Component